import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import Translator from "@/utils/common/Translator.ts";
import {Dialog} from "quasar";

export default class NaMaConfirmationDialog
{

  confirmationText: string;
  title: string;
  dialogType: string;
  ok: string = '';
  cancel: string = '';
  isPersistent: boolean;

  constructor(dialogType: string, message: string, isPersistent: boolean, title?: string) {
    this.dialogType = dialogType;
    this.title = title ?? "";
    this.confirmationText = message;
    this.isPersistent = isPersistent;
    switch (this.dialogType) {
      case ConfirmationDialogType.Ok:
        this.ok = Translator.translateId('ok');
        this.cancel = '';
        break;
      case ConfirmationDialogType.OkCancel:
        this.ok = Translator.translateId('ok');
        this.cancel = Translator.translateId('cancel');
        break;
      case ConfirmationDialogType.YesNo:
        this.ok = Translator.translateId('yes');
        this.cancel = Translator.translateId('no');
        break;
      default:
        break;
    }
  }

  static async okCancelConfirmationDialog(message: string, isPersistent: boolean, title?: string, alwaysLTR?: boolean): Promise<boolean> {
    let dialog: NaMaConfirmationDialog = new NaMaConfirmationDialog(ConfirmationDialogType.OkCancel, message, isPersistent, title);
    return await this.confirmDialog(dialog, isPersistent, alwaysLTR);
  }

  static async yesNoConfirmationDialog(message: string, isPersistent: boolean, title?: string): Promise<boolean> {
    let dialog: NaMaConfirmationDialog = new NaMaConfirmationDialog(ConfirmationDialogType.YesNo, message, isPersistent, title);
    return await this.confirmDialog(dialog, isPersistent);
  }

  static async okConfirmationDialog(message: string, isPersistent: boolean, title?: string): Promise<boolean> {
    let dialog: NaMaConfirmationDialog = new NaMaConfirmationDialog(ConfirmationDialogType.Ok, message, isPersistent, title);
    return await this.confirmDialog(dialog, isPersistent);
  }

  private static async confirmDialog(dialog: NaMaConfirmationDialog, isPersistent: boolean, alwaysLTR?: boolean) {
    return new Promise<boolean>((resolve) => {
      Dialog.create({
        component: ConfirmDialog,
        componentProps: {
          confirmationText: dialog.confirmationText,
          title: dialog.title,
          ok: dialog.ok,
          cancel: dialog.cancel,
          isPersistent: isPersistent,
          alwaysLTR
        }
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false));
    });
  }
}

export class ConfirmationDialogType
{
  static readonly YesNo: string = "YesNo";
  static readonly OkCancel: string = "OkCancel";
  static readonly Ok: string = "Ok";
}

